import { mutatorAction } from 'satcheljs';
import ItemCLPInfo from 'owa-mail-store/lib/store/schema/ItemCLPInfo';
import ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';

export default mutatorAction(
    'updateItemCLPInfoInMailStore',
    (itemToUpdate: ClientItem, itemCLPInfo: ItemCLPInfo) => {
        if (itemToUpdate) {
            itemToUpdate.itemCLPInfo = itemCLPInfo;
            if (itemCLPInfo?.selectedLabel) {
                itemToUpdate.MSIPLabelGuid = itemCLPInfo.selectedLabel.id;
            }
        }
    }
);
